import { StylesConfig } from "react-select";

export const defaultStyledSelectStyles: StylesConfig = {
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "44px",
    height: "44px",
    borderRadius: "8px",
    border: state.isDisabled ? "1px solid #E2E4E8" : "1px solid #D0D5DD",
    boxShadow: state.isFocused
      ? "rgba(0, 103, 112, 1)"
      : "0px 1px 2px 0px #1018280D",
    borderColor: state.isFocused ? "rgba(0, 103, 112, 1)" : base.borderColor,
    borderWidth: state.isFocused ? "1px" : base.borderWidth,
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    backgroundColor: state.isDisabled ? "#EEEFF2" : base.backgroundColor,

    "&:hover": {
      borderColor: state.isFocused ? "rgba(0, 103, 112, 1)" : base.borderColor,
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "8px 0 8px 14px",
    margin: 0,
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: "#667085",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingRight: 10,

    "> svg": {
      fill: "#718096",
      width: "20px",
      height: "20px",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: "#1A202C",
  }),
  option: (base, { isSelected }) => ({
    ...base,
    backgroundColor: isSelected ? "#00535c" : "",
    color: isSelected ? "#ffffff" : "#1F2937",
    cursor: "pointer",

    ":hover": {
      backgroundColor: "#F7F7F7",
      color: "#000000",
    },
  }),
};
